var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49372 5.25628C6.15201 4.91457 5.59799 4.91457 5.25628 5.25628C4.91457 5.59798 4.91457 6.152 5.25628 6.4937L10.7626 12L5.25628 17.5063C4.91457 17.848 4.91457 18.402 5.25628 18.7437C5.59799 19.0854 6.15201 19.0854 6.49372 18.7437L12.0001 13.2374L17.5063 18.7436C17.848 19.0853 18.402 19.0853 18.7437 18.7436C19.0854 18.4019 19.0854 17.8479 18.7437 17.5062L13.2375 12L18.7437 6.49384C19.0854 6.15213 19.0854 5.59812 18.7437 5.25641C18.402 4.91471 17.848 4.91471 17.5063 5.25641L12.0001 10.7626L6.49372 5.25628Z",
    fill: "currentColor",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.987d2c89989ed88371b62d8d2ca524ce.svg";
export { ForwardRef as ReactComponent };